module.exports = __webpack_public_path__ + "img/3.97382cbd.png";